import { useState } from 'react';
import { TableBody, TableHead } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import CommonModalButton from '../../../form-components/CommonModalButton';
import { getAppVersions } from '../../../api/appVersion';
import AppVersionManagementEditModal from './AppVersionManagementEditModal';
import {
  PageContainer,
  PageTitle,
  PageDescription,
  TableWrapper,
  StyledTable,
  HeaderCell,
  BodyCell,
  StyledTableRow,
  YnBadge,
  CheckMessagePreview,
} from './AppVersionManagementStyled';

const PLATFORM_LABELS = { I: 'iOS', A: 'Android' };
const APP_LABELS = { M: '회원앱', T: '강사앱', G: '매니저앱' };

const AppVersionManagement = () => {
  const user = useSelector(state => state.user.user);
  const [editTarget, setEditTarget] = useState(null);

  const { data: versions = [] } = useQuery({
    queryKey: ['appVersions'],
    queryFn: () => getAppVersions(user.token),
    enabled: !!user.token,
  });

  return (
    <PageContainer>
      <PageTitle>앱 버전 관리</PageTitle>
      <PageDescription>
        플랫폼·앱별 최신 버전과 강제업데이트 사용 여부를 관리합니다. 강제업데이트를 켜면 최신 버전 미만 클라이언트는
        닫을 수 없는 업데이트 안내를 보게 됩니다 — 켜기 전 해당 버전이 스토어에 실제로 반영됐는지 먼저 확인하세요.
      </PageDescription>

      <TableWrapper>
        <StyledTable>
          <TableHead>
            <StyledTableRow>
              <HeaderCell>플랫폼</HeaderCell>
              <HeaderCell>앱</HeaderCell>
              <HeaderCell>최신 버전</HeaderCell>
              <HeaderCell>강제업데이트</HeaderCell>
              <HeaderCell>점검 공지</HeaderCell>
              <HeaderCell></HeaderCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {versions.map(row => (
              <StyledTableRow key={row.id}>
                <BodyCell>{PLATFORM_LABELS[row.phoneType] || row.phoneType}</BodyCell>
                <BodyCell>{APP_LABELS[row.appType] || row.appType}</BodyCell>
                <BodyCell>{row.version}</BodyCell>
                <BodyCell>
                  <YnBadge active={row.forceUpdateYn === 'Y'}>{row.forceUpdateYn === 'Y' ? '사용' : '안 함'}</YnBadge>
                </BodyCell>
                <BodyCell>
                  <CheckMessagePreview title={row.checkMessage}>
                    {row.checkYn === 'Y' ? row.checkMessage || '(문구 없음)' : '안 함'}
                  </CheckMessagePreview>
                </BodyCell>
                <BodyCell>
                  <CommonModalButton variant="submit" onClick={() => setEditTarget(row)}>
                    수정
                  </CommonModalButton>
                </BodyCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableWrapper>

      <AppVersionManagementEditModal open={!!editTarget} target={editTarget} onClose={() => setEditTarget(null)} />
    </PageContainer>
  );
};

export default AppVersionManagement;
